<template>
  <b-field grouped group-multiline>
    <b-field
      class="column is-4"
      label="nome"
      :type="{'is-danger': errors.has('nome')}"
      :message="errors.first('nome')"
    >
      <b-input v-model="proposta.nome" v-validate="'required'" name="nome"></b-input>
    </b-field>

    <b-field
      class="column is-4"
      label="número"
      :type="{'is-danger': errors.has('numero')}"
      :message="errors.first('numero')"
    >
      <b-input v-model="proposta.numero" v-validate="'required'" name="numero"></b-input>
    </b-field>

    <b-field
      class="column is-4"
      label="grade"
      :type="{'is-danger': errors.has('grade')}"
      :message="errors.first('grade')"
    >
      <b-select
        placeholder="Selecione uma grade"
        icon="file-document"
        expanded
        v-model="proposta.grade_id"
        v-validate="'required'"
        name="grade"
      >
        <option v-for="grade in grades" :key="grade.id" :value="grade.id">{{grade.nome}}</option>
      </b-select>
    </b-field>

    <b-field class="column is-4 uploadlabel proposta" label="Selecione o Arquivo">
      <b-upload v-model="proposta.file">
        <a class="button uploadbutton">
          <span>Selecionar arquivo</span>
        </a>
      </b-upload>
      <span class="file-name" v-if="proposta.file">{{ proposta.file.name }}</span>
    </b-field>

    <b-field
      class="column is-4"
      label="Escola"
      :type="{'is-danger': errors.has('grade')}"
      :message="errors.first('grade')"
    >
      <multiselect
        v-model="proposta.escolas"
        tag-placeholder="Adiconar escola"
        placeholder="Conteudo disponível apenas para:"
        label="name"
        track-by="id"
        :options="escolas"
        :multiple="true"
        :taggable="true"
      ></multiselect>
    </b-field>

    <b-table id="tablevideo">
      <template slot="empty">
        <th class="thUrl" >
          <span>URL</span>
          <b-switch true-value="1" false-value="0" v-model="urlOrVideo" type="is-success"></b-switch>
        </th>
        <tr v-for="(row, index) in proposta.videos" :key="index">
          <b-table-column label="Ordem">
            <b-input v-model="row.ordem" style="width:100px !important;"></b-input>
          </b-table-column>
          <b-table-column label="Título">
            <b-input v-model="row.titulo"></b-input>
          </b-table-column>
          <b-table-column label="Descrição">
            <b-input maxlength="280" type="textarea" v-model="row.descricao"></b-input>
          </b-table-column>
          <b-table-column label="Vídeo">
            <label v-if="urlOrVideo == 0" class="videoContainer">
              <input
                accept="video/mp4, video/x-m4v, video/*"
                type="file"
                placeholder=""
                @change="setVideoName($event, row)"
                :id="index"
                v-if="!row.video_url || !row.progress"
              />
              <p v-else>{{row.video_url}}</p>
            </label>
            <input v-else type="text" v-model="row.video_url" />
          </b-table-column>
          <td>
            <a
              v-if="!row.video_url && !row.progress"
              v-on:click="removeElement(index);"
              style="cursor: pointer"
            >Remover</a>
            <span v-if="!!row.progress && !urlOrVideo">{{ row.progress }}%</span>
          </td>
        </tr>
      </template>
    </b-table>
  </b-field>
</template>
<script>
import Upload from "@/services/UploadVideo";
import GradeService from "@/services/GradeService";
import EscolaService from "@/services/EscolaService";

export default {
  data() {
    return {
      urlOrVideo: 0,
      grades: [],
      escolas: []
    };
  },

  name: "propostaFields",
  props: ["proposta"],
  methods: {
    removeElement: function(index) {
      this.proposta.videos.splice(index, 1);
    },
    setVideoName: function(event, row) {
      //console.log(row)
      let file = event.target.files[0];
      Upload.uploadVideo(
        file,
        uri => {
          row.video_url = uri;
        },
        progress => {
          row.progress = progress;
        }
      );
    }
  },
  components: {},
  created() {
    GradeService.Index(this.$parent.$parent.cargo, this.$parent.$parent.cargoId).then(result => {
      this.grades = result.data;
    });
    EscolaService.Index(this.$parent.$parent.cargo, this.$parent.$parent.cargoId).then(result => {
      result.data.forEach(escola => {
        this.escolas.push({ name: escola.nome, id: escola.id });
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.thUrl {
  display: flex;
  right: 65px;
  position: absolute;
  top: 245px;
}
.thUrl span {
  margin-top: 5px;
  margin-right: 10px;
}
</style>